









































































import {Vue, Component, Prop} from 'vue-property-decorator'
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";
import VueError from '@/components/VueError.vue';
import GroupAccessView from '@/components/access/GroupAccessView.vue';
import {ApiKey, Column} from "@/types/core";
import tippy from "tippy.js";

@Component({
  components: {
    MobileFriendlyRow,
    GroupAccessView,
    VueError
  }
})

export default class ApiKeyRowMobile extends Vue {

  @Prop({ default: {},  type: Object}) apiKey!: ApiKey;
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
    {colName: 'api-key', colStyle:{'flex-grow':1}, colKey:'apiKey'}
  ];
  error:string = '';

  async mounted() {
    // nothing here yet
    tippy('[data-tippy-content]');
  }

  maskApiKey(apiKey:string):string {
    return apiKey.substring(0, 10) + "*****" + apiKey.substring(30);
  }

  // this is not super elegant but it works reliably
  async copyToClipboard(apiKey:string) {

    // @ts-ignore
    let ret = await this.$copyText(apiKey);

    const button = document.querySelector(`#api-key-${apiKey}`) as Element;

    // @ts-ignore
    let localTippy = button._tippy as any;

    localTippy.setContent('copied!');
    localTippy.show();

    setTimeout(() => localTippy.hide(), 2000);
    setTimeout(() => localTippy.setContent('copy to the clipboard'), 2500);
  }

}

